<div class="modal-header" mat-dialog-title>
    <h4 class="modal-title">{{ data.title }}</h4>
</div>
<div class="modal-body" mat-dialog-content>
    <p>{{ data.message }}</p>
</div>
<div class="modal-footer">
    <button mat-button (click)="close()" tabindex="-1">
        {{ data.cancelText }}
    </button>
    <button mat-raised-button color="primary" (click)="ok()">
        {{ data.okText }}
    </button>
</div>
